import { render, staticRenderFns } from "./Denunciation-count-graph.vue?vue&type=template&id=3173ece8&scoped=true"
import script from "./Denunciation-count-graph.vue?vue&type=script&lang=js"
export * from "./Denunciation-count-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3173ece8",
  null
  
)

export default component.exports